// export const language = {
//     "strings": [
//         {
//             "id": "bagegametext_1",
//             "text": "FIRST TEXT EN"
//         },
//         {
//             "id": "bagegametext_2",
//             "text": "SECOND TEXT EN"
//         }
//     ]
// }


export enum language {
    COMPANY_NAME = "BI",
    bagegametext_1 = "GRAND JOKER",
    bagegametext_2 = "SECOND TEXT EN",
    bagegametext_3 = "If a single Treasure Wild, Dragon \n Wild, and Knight Wild land together,\n all wilds are combined to create instant wins, multipliers,\n and a trail of flaming wilds.",
    bagegametext_4 = "core:en:If a single Treasure Wild, Dragon.",
    introtext_4 = "Welcome To FREEGAME ",
    outrotext_4 = "You Won !!",
    introtext_5 = "Press Anywhere To Continue.. ",

    //AUTOPLAY TEXT--------------------
    autoplayText_1 = "AUTOPLAY SETTING",
    autoplayText_2 = "Stop autoplay",
    autoplayText_3 = "On any win",
    autoplayText_4 = "If free spin are won",
    autoplayText_5 = " AUTO PLAY",
    autoplayText_6 = "If Single win exceeds",
    autoplayText_7 = "If balance increase by",
    autoplayText_8 = "If balance decrease by",
    // autoplayText_9 = "5",
    // autoplayText_10 = "10",
    // autoplayText_11 = "15",
    // autoplayText_12 = "20",
    // autoplayText_13 = "30",
    // autoplayText_14 = "40",
    // autoplayText_15 = "50",
    // autoplayText_16 = "75",
    // autoplayText_17 = "100",
    // autoplayText_18 = "0.00",
    // autoplayText_19 = "120.00",
    autoplayText_20 = "START",
    autoplayText_21 = "CANCEL",
    //autoplayText_22 = "START AUTOPLAY",
    autoplayText_23 = "Cancel",


    autoplayStoppedTextHeading = "Auto Play Information",
    autoplayStoppedText1 = "Autoplay has stopped due to: ",
    autoplayStoppedText2 = "- loss limit reached",


    //DESKTOP SETTING PANEL---------------------------
    desktopSettingPanel_Text_1 = "SETTINGS",
    desktopSettingPanel_Text_2 = "Show Intro Screen",
    desktopSettingPanel_Text_3 = "Full Screen",
    desktopSettingPanel_Text_4 = "SOUND SETTINGS",
    desktopSettingPanel_Text_5 = "Music",
    desktopSettingPanel_Text_6 = "SPIN SETTINGS",
    desktopSettingPanel_Text_7 = "Press Space Bar to Spin",
    desktopSettingPanel_Text_8 = "Turbo Spin",


//MOBILE VIEW PANEL TEXT-----------------------------
    mobViewPanel_Text_1 = "BET",
    mobViewPanel_Text_2 = "RULES",
    mobViewPanel_Text_3 = "Setting",
    mobViewPanel_Text_4 = "Rules",
    mobViewPanel_Text_5 = "Autoplay",
    mobViewPanel_Text_6 = "Bet",


    //MENU TEXT--------------------
    menuText_1 = "TOTAL BET",
    menuText_2 = "QUICK SPIN",
    menuText_3 = "AMBIENT MUSIC",
    menuText_4 = "SOUND FX",
    menuText_5 = "PLEASE SELECT YOUR COIN VALUE:",
    menuText_6 = "Please Select Your Coin Value:",
    menuText_7 = "CONTINUE",
    menuText_8 = "0.01",
    menuText_9 = "0.05",
    menuText_10 = "0.07",
    menuText_11 = "0.1",
    menuText_12 = "0.5",
    menuText_13 = "0.7",
    menuText_14 = "1",
    menuText_15 = "2",


    //LOADER TEXT--------------------
    loaderText_1 = "loading",
    loaderText_2 = "Complete",
}
